// MF-67 — Headline numbers for the current filters: entries, one tile per type, net points, students.
import { Typography } from '@mui/material'
import { fmtNumber, fmtPct, orderedTypes, typeStyle } from './chartTheme'

const Tile = ({ label, value, sub, accent }) => (
  <div
    className='flex flex-col'
    style={{
      gap: 4,
      padding: '16px 20px',
      background: '#fff',
      border: '1px solid rgb(226, 232, 240)',
      borderRadius: 12,
      borderTop: `3px solid ${accent || 'rgb(226, 232, 240)'}`,
      minWidth: 0
    }}
  >
    <Typography style={{ fontSize: 12, color: 'rgb(100, 116, 139)' }}>{label}</Typography>
    <Typography
      style={{
        fontSize: 26,
        fontWeight: 600,
        lineHeight: 1.15,
        color: 'rgb(15, 23, 42)',
        fontVariantNumeric: 'tabular-nums'
      }}
    >
      {value}
    </Typography>
    {sub ? <Typography style={{ fontSize: 12, color: 'rgb(100, 116, 139)' }}>{sub}</Typography> : null}
  </div>
)

const KpiTiles = ({ totals = {}, byType = [], types = { list: [], byCode: new Map() } }) => {
  const entries = totals.entries || 0
  const points = totals.points || 0
  const codes = orderedTypes(
    byType.filter((r) => r.count > 0).map((r) => r.type),
    types.list
  )
  return (
    <div className='grid' style={{ gap: 16, gridTemplateColumns: 'repeat(auto-fit, minmax(170px, 1fr))' }}>
      <Tile label='Entries' value={fmtNumber(entries)} sub='Matching the filters' />
      {codes.map((code) => {
        const count = byType.find((r) => r.type === code)?.count || 0
        const st = typeStyle(code, types.byCode)
        return (
          <Tile
            key={code}
            label={st.label}
            value={fmtNumber(count)}
            sub={`${fmtPct(count, entries)} of entries`}
            accent={st.color}
          />
        )
      })}
      <Tile
        label='Net points'
        value={`${points > 0 ? '+' : ''}${fmtNumber(points)}`}
        sub='Sum of all entry points'
      />
      <Tile label='Students' value={fmtNumber(totals.students || 0)} sub='With at least one entry' />
    </div>
  )
}

export default KpiTiles
